import { Injectable }   from '@angular/core';

import { Field, Condition, NumberField, IntegerField } from '../models';
import { TranslatorService } from './translator.service';

@Injectable()
export class FormulaService {
    
    constructor(
        private translatorService: TranslatorService
    ) { }

    calculateFormulaValuesByItem(formulas, viewItem) {
        var formulaResults = [];
        formulas.forEach(f => {
            var formula = JSON.parse(JSON.stringify(f));
            var expression = this.translatorService.translate(null, viewItem, f.expression);
            try {
                formula.result =  (expression) ? eval(expression) : null;
                if (Number.isNaN(formula.result)) formula.result = f.value_if_invalid;
            } catch (e) {
                formula.result = f.value_if_invalid;
            }

            switch (formula.data_type) {
                case NumberField.control_type: formula.result = Number.parseFloat(formula.result); break;
                case IntegerField.control_type: formula.result = Number.parseInt(formula.result); break;
            }

            formulaResults.push(formula);
        });
        return formulaResults;
    }
    
    calculateFormulaValues(formulas, oldFormFields:Array<Field<any>>, newFormFields:Array<Field<any>>) {
        var formulaResults = [];
        formulas.forEach(f => {
            var formula = JSON.parse(JSON.stringify(f));
            var expression = this.translatorService.translate(oldFormFields, newFormFields, f.expression);
            try {
                formula.result =  (expression) ? eval(expression) : null;
            } catch (e) {
                formula.result = f.value_if_invalid;
            }

            switch (formula.data_type) {
                case NumberField.control_type: formula.result = Number.parseFloat(formula.result); break;
                case IntegerField.control_type: formula.result = Number.parseInt(formula.result); break;
            }

            formulaResults.push(formula);
        });
        return formulaResults;
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/formula.service.ts